// extracted by mini-css-extract-plugin
module.exports = {"tcLinks":"purify_index__tcLinks--xsiyJ","ratesFees":"purify_index__ratesFees--3XsAJ","offerTerms":"purify_index__offerTerms--3LpdN"};